// import type { Perspective } from "@/tags/perspectives-carousel/types.ts";
import type { Author } from "@/data/authors";
import type { AttrClass } from "node_modules/marko/tags-html";
import s from "./style.module.css";
export interface Input {
    user: Author;
    class?: AttrClass;
}

<div class=[s.container, input.class]>
    <img class=s.avatar src=(input.user.src) alt=(input.user.name)>
    <div class=s.user>
        <div class=s.name>
            ${input.user.name}
        </div>
        <div class=s.title>
            ${input.user.title}
        </div>
    </div>
</div>
